import { ComponentRecognizer } from '../../ComponentRecognizer/ComponentRecognizer';
import type { FooterBlockBadgesType } from '../types';
import { registerComponents } from '../../ComponentRecognizer/componentRegistry';
import { ComponentTypes } from '../../../../interfaces';

type BlockBadgesProps = {
  data: FooterBlockBadgesType;
};

export const BlockBadges = ({ data }: BlockBadgesProps) => (
  <div key={`block-badges-${data.id}`} className="flex gap-[0.8rem]">
    {data.paragraph?.map((item, index) => (
      <ComponentRecognizer
        // eslint-disable-next-line react/no-array-index-key
        key={`block-badges-component-recognizer-${index}`}
        item={item}
      />
    ))}
  </div>
);

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({ [ComponentTypes.BlockBadges]: BlockBadges });
